export default "__VITE_ASSET__CshnqbZS__"